/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import type {
    GroupByType,
    SwingTimingData,
} from 'leaderboard/scripts/swing-path/types/globals'
import React from 'react'
import getShortPitchName from '../utils/get-short-pitch-name.ts'
import getImageUrl from './utils/get-image-url.ts'
import getPitcherType from './utils/get-pitcher-type.ts'
import type { GroupByLogic } from './utils/do-group-by-logic.ts'
import { getPitchNameGrouping } from '../utils/pitch-names'

const imageSize = 45

type PlayerCardProps = {
    row: SwingTimingData
    groupByLogic: GroupByLogic
    handleSelect: (d: SwingTimingData) => void
    disabled?: boolean
    type: GroupByType
}

export default function PlayerCard({
    row,
    groupByLogic,
    handleSelect,
    disabled = false,
    type,
}: PlayerCardProps) {
    const { hasGroupBys, extraGroupBys, groupByTitles, groupByDisplayFns } =
        groupByLogic

    const secondaryClassName = 'swing-timing-player-card-search'

    const imgSrc = getImageUrl(type, row, {
        playerImageSource: 'midfield',
        playerImageSize: imageSize * 3,
    })

    const cardStyle = {
        opacity: disabled ? 0.5 : 1,
        cursor: disabled ? 'not-allowed' : 'pointer',
    }

    return (
        <button
            type="button"
            key={row.uniqueId}
            className={`swing-timing-player-card ${secondaryClassName}`}
            onClick={() => handleSelect(row)}
            disabled={disabled}
            style={cardStyle}
        >
            <img
                alt={row.name}
                className="swing-timing-player-card-image"
                src={imgSrc}
                height={imageSize * 1}
                width={imageSize * 1}
            />
            <div
                style={{
                    flexGrow: 2,
                    minWidth: 0,
                    margin: '0 1rem',
                }}
            >
                <div className="swing-timing-player-card-name swing-timing-no-wrap-ellipsis">
                    {row.name}
                </div>
                {hasGroupBys && (
                    <div>
                        {extraGroupBys
                            .map((key, i) => {
                                if (key === 'api_pitch_type_group03') {
                                    return getShortPitchName(row[key])
                                }

                                if (key === 'api_pitch_type_group09') {
                                    return `Group: ${getPitchNameGrouping(
                                        row[key] || ''
                                    )}`
                                }

                                const label = groupByTitles[i]

                                const value = groupByDisplayFns[i](
                                    row[key],
                                    row
                                )

                                return `${label}${value}`
                            })
                            .join(' ⋅ ')}
                    </div>
                )}
            </div>
            {/* <div
                className="swing-timing-no-wrap-ellipsis"
                style={{
                    color: getPitchTypeColor(row.api_pitch_type_group03, true),
                }}
            >
                {row.api_pitch_type_group03 &&
                    getShortPitchName(row.api_pitch_type_group03)}
            </div> */}
            {row.pitch_hand_type !== 'X' && (
                <div
                    style={{
                        textAlign: 'right',
                        width: '60px',
                    }}
                >
                    {getPitcherType(row)}
                </div>
            )}
        </button>
    )
}
